import React, { useState, useEffect, useRef } from 'react';
import {
    Box, Typography, TextField, Button, Dialog, DialogContent, List, ListItem, ListItemText,
    ListItemIcon, IconButton, styled, Divider, Grid, FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddressService from '../../Profile/addressService';
import AlertService from "../../../components/Alerts/alerts";
import { useTranslation } from 'react-i18next';
import AddressPickerPopup from '../../../components/AddressPicker/AddressPickerPopup';

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        borderRadius: '16px',
        width: '90%',
        maxWidth: '400px',
        margin: 0,
    },
}));

const Header = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
    borderBottom: '1px solid #e0e0e0',
}));

const AddressIcon = styled(LocationOnIcon)(({ theme }) => ({
    color: theme.palette.primary.main,
    marginRight: '8px',
}));

const AddNewText = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    cursor: 'pointer',
}));

const StyledListItem = styled(ListItem)(({ theme }) => ({
    borderBottom: '1px solid #e0e0e0',
    '&:last-child': {
        borderBottom: 'none',
    },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
    marginBottom: '16px',
}));

const ActionButton = styled(Button)(({ theme }) => ({
    borderRadius: '20px',
    padding: '10px 20px',
}));

const AddressPopup = ({ open, onClose, addresses, onSelectAddress, onAddNew }) => {
    const [isAddingNew, setIsAddingNew] = useState(false);
    const { t } = useTranslation();
    const [popupOpen, setPopupOpen] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState({});

    const handleOpenPopup = () => setPopupOpen(true);
    const handleClosePopup = () => setPopupOpen(false);
    const handleSelectAddress = (address) => {
        //iph todo: 47
        //console.log("address", address);
        setSelectedAddress(address);
        setFormData({
            location: address.location,
            block: address.block,
            unit: address.unit,
            label: address.label,
            latitude: address.latitude,
            longitude: address.longitude,
            address_url: `https://www.google.com/maps?q=${address.latitude},${address.longitude}`,
            city: address.city,
            state: address.state,
            postalCode: address.postalCode,
            country: address.country,
        });
    };

    const [formData, setFormData] = useState({
        location: '',
        block: '',
        unit: '',
        label: '',
        latitude: '',
        longitude: '',
        address_url: '',
        city: '',
        state: '',
        postalCode: '',
        country: '',
    });

    const [storedUser, setStoredUser] = useState(() => JSON.parse(localStorage.getItem('user')));

    // Handle form field changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    };


    const handleAddNew = () => {
        setIsAddingNew(true);
    };

    const handleBack = () => {
        setIsAddingNew(false);
        setFormData({
            location: '',
            block: '',
            unit: '',
            label: '',
            latitude: '',
            longitude: '',
            address_url: '',
            city: '',
            state: '',
            postalCode: '',
            country: '',
        });
    };

    const handleAddAddress = async () => {
        try {
            const data = {
                user_id: storedUser._id,
                label: '',
                unit: formData.unit,
                location: formData.location,
                block: formData.block,
                city: formData.city,
                state: formData.state,
                postalCode: formData.postalCode,
                country: formData.country,
                latitude: formData.latitude,
                longitude: formData.longitude
            };
            const response = await AddressService.addAddress(data);

            if (response.data.status) {
                AlertService.swalSuccessAlert("Address added successfully.");
                onAddNew(response.data.address); // Assuming the API returns the newly added address
                handleBack();
            } else {
                AlertService.swalErrorAlert(response.data.message?.[0]?.message || response.data.message || "Error adding address.");
            }
        } catch (error) {
            AlertService.swalErrorAlert("Error adding address?. Please try again.");
        }
    };

    return (
        <StyledDialog open={open} onClose={onClose} fullWidth>
            <Header>
                {isAddingNew ? (
                    <IconButton onClick={handleBack}>
                        <ArrowBackIcon />
                    </IconButton>
                ) : (
                    <Box display="flex" alignItems="center">
                        <AddressIcon />
                        <Typography variant="subtitle1">Address</Typography>
                    </Box>
                )}
                {!isAddingNew && (
                    <AddNewText onClick={handleAddNew}>Add New</AddNewText>
                )}
            </Header>
            <DialogContent sx={{ padding: 0 }}>
                {isAddingNew ? (
                    <Box sx={{ p: 2 }}>

                        {/* <Typography variant="h6" sx={{ mb: 2 }}>Address</Typography>
                        <Grid sx={{ mt: '2px' }} container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    label="Selected Address"
                                    value={selectedAddress.location || ''}
                                    fullWidth
                                    onClick={handleOpenPopup}
                                    readOnly
                                />
                                <AddressPickerPopup
                                    open={popupOpen}
                                    onClose={handleClosePopup}
                                    onSelect={handleSelectAddress}
                                />
                            </Grid >
                        </Grid > */}


                        <Grid sx={{ mt: '2px' }} container spacing={2}>
                            <Grid item xs={6}>
                                <StyledTextField
                                    fullWidth
                                    placeholder="Block or Street name"
                                    name="block"
                                    value={formData.block}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <StyledTextField
                                    fullWidth
                                    placeholder="Unit/House no."
                                    name="unit"
                                    value={formData.unit}
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <StyledTextField
                                    fullWidth
                                    placeholder="City"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                />
                            </Grid>
                            {/* <Grid item xs={6}>
                                <StyledTextField
                                    fullWidth
                                    placeholder="State/Province"
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                />
                            </Grid> */}

                            <Grid item xs={6}>
                                <StyledTextField
                                    select
                                    fullWidth
                                    label="State"
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="">Select State</MenuItem>
                                    <MenuItem value="Johor">Johor</MenuItem>
                                    <MenuItem value="Kedah">Kedah</MenuItem>
                                    <MenuItem value="Kelantan">Kelantan</MenuItem>
                                    <MenuItem value="Melaka">Melaka</MenuItem>
                                    <MenuItem value="Negeri Sembilan">Negeri Sembilan</MenuItem>
                                    <MenuItem value="Pahang">Pahang</MenuItem>
                                    <MenuItem value="Perak">Perak</MenuItem>
                                    <MenuItem value="Perlis">Perlis</MenuItem>
                                    <MenuItem value="Penang">Penang</MenuItem>
                                    <MenuItem value="Sabah">Sabah</MenuItem>
                                    <MenuItem value="Sarawak">Sarawak</MenuItem>
                                    <MenuItem value="Selangor">Selangor</MenuItem>
                                    <MenuItem value="Terengganu">Terengganu</MenuItem>
                                    <MenuItem value="Kuala Lumpur">Kuala Lumpur</MenuItem>
                                    <MenuItem value="Labuan">Labuan</MenuItem>
                                    <MenuItem value="Putrajaya">Putrajaya</MenuItem>
                                </StyledTextField>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <StyledTextField
                                    fullWidth
                                    placeholder="Postal Code"
                                    name="postalCode"
                                    value={formData.postalCode}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <StyledTextField
                                    fullWidth
                                    placeholder="Country"
                                    name="country"
                                    value={formData.country}
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <ActionButton
                                fullWidth
                                variant="outlined"
                                onClick={handleBack}
                            >
                                Cancel
                            </ActionButton>
                            <ActionButton
                                fullWidth
                                variant="contained"
                                onClick={handleAddAddress}
                            >
                                Add
                            </ActionButton>
                        </Box>
                    </Box>
                ) : (
                    <List sx={{ padding: 0 }}>
                        {addresses?.map((address) => (
                            <StyledListItem key={address?._id} onClick={() => onSelectAddress(address)} button>
                                <ListItemIcon>
                                    <LocationOnIcon sx={{ color: 'orange' }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={<Typography variant="subtitle1">{address?.location}</Typography>}
                                />
                            </StyledListItem>
                        ))}
                    </List>
                )}
            </DialogContent>
            <style>{`
    .pac-container {
        z-index: 9999 !important;
        position: absolute !important;
    }

    .pac-item {
        z-index: 10000 !important;
    }
`}</style>

        </StyledDialog>
    );
};

export default AddressPopup;